import type { ReduxState } from './druid/types/internal/ReduxState';

export default ({ sendBoxValue }: ReduxState): string => sendBoxValue;
